import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[kalSelectTriggerValue]',
    standalone: false
})
export class KalSelectTriggerValueDirective {

  constructor(public view: TemplateRef<any>) {
  }

}
